
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.6 2.9v2h4.314v1.2l-.173-.002a1.516 1.516 0 00-1.304 1.226l-.02.142-.009.098v-.006l-1.143 12.093a1.6 1.6 0 01-1.593 1.449H8.328a1.6 1.6 0 01-1.593-1.45L5.567 7.296A1.516 1.516 0 004.282 6.1H4V4.9h4.4v-2h7.2zm1.74 3.2H6.66l1.27 13.438a.4.4 0 00.398.362h7.344a.4.4 0 00.398-.362L17.34 6.1zM12.6 7.5v10.796h-1.2V7.5h1.2zm3 0l-.52 9.567a1.265 1.265 0 01-1.264 1.197L14.401 7.5H15.6zm-6.028 0l.585 10.764a1.265 1.265 0 01-1.263-1.197L8.375 7.5h1.198-.001zM14.4 4.1H9.6v.8h4.8v-.8z","fill":"#000","fill-rule":"evenodd"}})])
          )
        }
      }
    